import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ItemCommentDialogData {
  itemName: string;
  comment: string;
  readOnly: boolean;
}

@Component({
  selector: 'app-item-comment',
  templateUrl: './item-comment.component.html',
  styleUrls: ['./item-comment.component.scss'],
})
export class ItemCommentComponent {
  readonly maxLength = 500;
  comment: string;

  constructor(
    public dialogRef: MatDialogRef<ItemCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ItemCommentDialogData
  ) {
    this.comment = data?.comment || '';
  }

  save(): void {
    this.dialogRef.close({ saved: true, comment: this.comment.trim() });
  }

  cancel(): void {
    this.dialogRef.close({ saved: false });
  }
}
